import { React, useEffect, useState, useContext, useMemo } from "react";
import LoadingOverlay from "react-loading-overlay";
import ReactBSAlert from "react-bootstrap-sweetalert";
import {
  Card,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  FormGroup,
  Input,
  Form,
  Button,
} from "reactstrap";
import { NavLink as DomNavLink, useHistory } from "react-router-dom";
import Switch from "react-bootstrap-switch";
import { ToastContainer, toast } from "react-toastify";
LoadingOverlay.propTypes = undefined;
import { MainContext } from "context/MainContext.js";

import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

import { faHome, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

function FirmwareUpgrade() {
  const [showLoading, setShowLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [errorMsg, setErrorMsg] = useState([]);
  const history = useHistory();
  const privileges = useContext(MainContext);
  const [initialValue, setInitialValue] = useState(null);

  // Object containing all the form values
  const [firmwareUpgradeValues, setFirmwareUpgradeValues] = useState({
    firmwareUpgradeEnable: "false",
  });

  // Object containing all error messages for every inputs
  const [firmwareUpgradeStates, setFirmwareUpgradeStates] = useState({
    firmwareUpgradeEnable: "",
  });

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["automations.firmware.upgrade.edit"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    } else {
      fetchData();
    }
  }, []);

  const fetchData = () => {
    const start = Date.now();
    fetch("/api/v1/automation/firmware/upgrade/list", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        if (actualData.status == "200") {
          setFirmwareUpgradeValues(actualData.data);
          setInitialValue(actualData.data.firmwareUpgradeEnable);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleSwitchChange = (e) => {
    const { props, state } = e;

    setFirmwareUpgradeValues({
      ...firmwareUpgradeValues,
      [props.name]: state.value.toString(),
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowLoading(true);

    fetch("/api/v1/automation/firmware/upgrade/edit", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        firmwareUpgradeEnable: firmwareUpgradeValues.firmwareUpgradeEnable,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error(
            "A problem occured while updating the firmware upgrade values",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
        } else {
          setInitialValue(firmwareUpgradeValues.firmwareUpgradeEnable);
          setErrorMsg([]);
          toast.success("Firmware Upgrade values saved successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        {alert}
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </DomNavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Automations</BreadcrumbItem>
                  <BreadcrumbItem>Firmware Upgrade</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                {errorMsg.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      {errorMsg.map((d, index) => (
                        <li key={index}>{d}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col>
                      <label className={"settingLabel"}>
                        Automatic Firmware Upgrade &nbsp;
                        <a className="vmElement">
                          <FontAwesomeIcon icon={faInfoCircle} />
                        </a>
                        <ReactTooltip
                          anchorSelect=".vmElement"
                          place="top"
                          style={{ textAlign: "left", zIndex: "100" }}
                        >
                          The automatic upgrade only applies to the first
                          announcement of each device and uses the baseline
                          firmware version.
                        </ReactTooltip>
                      </label>
                      <FormGroup>
                        <Switch
                          name="firmwareUpgradeEnable"
                          offColor="success"
                          offText={<i className="nc-icon nc-simple-remove" />}
                          onColor="success"
                          onText={<i className="nc-icon nc-check-2" />}
                          onChange={handleSwitchChange}
                          value={
                            firmwareUpgradeValues["firmwareUpgradeEnable"] ==
                            "true"
                              ? true
                              : false
                          }
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button
                    className="btn-round"
                    color="info"
                    type="submit"
                    disabled={
                      firmwareUpgradeValues.firmwareUpgradeEnable ===
                      initialValue
                    }
                  >
                    Save
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default FirmwareUpgrade;
